import React from 'react';
import { Stack } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemProductDetails.scss';

type Props = {
  item: LineItem;
  showColor?: boolean;
};

export const LineItemProductDetails: React.FC<Props> = ({
  item: {
    attributes: { designerName, productName, color }
  },
  showColor = true
}) => {
  return (
    <Stack space={1}>
      <div className="LineItemProductDetails__designer">{designerName}</div>
      <div>{productName}</div>
      {showColor && <div className="LineItemProductDetails__color">Color: {color}</div>}
    </Stack>
  );
};
